import { Field, TextInput, SectionHeader } from "./Field";

const REF_KEYS = ["reference_1", "reference_2", "reference_3"];
const LABELS = ["Reference One", "Reference Two", "Reference Three"];

export default function StepReferences({ form, updateRef }) {
  return (
    <div>
      <SectionHeader
        eyebrow="Chapter IV"
        title="Personal references."
        description="Three individuals who know you well — not family members, ideally."
      />

      <div className="space-y-10">
        {REF_KEYS.map((key, idx) => {
          const ref = form[key];
          return (
            <div key={key} className="space-y-5">
              <p className="font-heading text-xl text-[#A67C2E]">{LABELS[idx]}</p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Field label="Name" required testid={`field-${key}-name`}>
                  <TextInput
                    value={ref.name}
                    onChange={(v) => updateRef(key, { name: v })}
                    placeholder="Full name"
                    testid={`input-${key}-name`}
                  />
                </Field>
                <Field label="Phone" required testid={`field-${key}-phone`}>
                  <TextInput
                    type="tel"
                    value={ref.phone}
                    onChange={(v) => updateRef(key, { phone: v })}
                    placeholder="(555) 123-4567"
                    testid={`input-${key}-phone`}
                  />
                </Field>
                <Field label="Relation" required testid={`field-${key}-relation`}>
                  <TextInput
                    value={ref.relation}
                    onChange={(v) => updateRef(key, { relation: v })}
                    placeholder="Colleague, friend…"
                    testid={`input-${key}-relation`}
                  />
                </Field>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
